import React, { Component } from "react";
import {
  Text,
  View,
  Image,
  ScrollView,
  Dimensions,
  Platform,
} from "react-native";
import {
  postSingle,
  Flex,
  Padding,
  Margin,
  button,
  Helpers,
  aboutAuthor,
  pageContent,
  pageCover,
  FontFamily,
  FontWeight,
  Colors,
  input,
  bannerStyles,
  Messages,
  Typo,
} from "../../styles/appStyles";

import TouchableOpacityLinkExternal from "../touchable-opacity-link-external";
import CustomImage from "../custom-image";
import { helpers } from "../../utils/helpers";
import PageBreak from "../page-break";
import ButtonGradient from "../button-gradient";
import getImagePath from "../../utils/image-helper";
import { InAppBrowser } from "react-native-inappbrowser-reborn";
import EventTicket from "../../../../assets/img/Tmc-private-ticket-image.png";

export class JoinYoutube extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {};

  pushInformationToDataLayer = () => {
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "more_info_interaction",
      custom_user_id: this.props.custom_user_id || "NA",
      user_status: this.props.custom_user_id ? "logged in" : "guest",
      article_section: "catch up on all the past events",
      newsletter_section: "NA",
      CTA_text: "all videos",
      CTA_position: "bottom",
      category_type: "NA",
      scroll_depth: helpers.getScrollDepth(),
    });
    dataLayer.push({
      event: "banner_interaction",
      custom_user_id: this.props.custom_user_id || "NA",
      user_status: this.props.custom_user_id ? "logged in" : "guest",
      category_type: "NA",
      banner_name: "catch up on all the past events",
      banner_position: "bottom",
      CTA_text: "all videos",
      scroll_depth: helpers.getScrollDepth(),
    });
  };

  async openLink(url) {
    try {
      if (
        (await InAppBrowser.isAvailable()) &&
        !url.includes("mailto:") &&
        url.startsWith("http")
      ) {
        let { darkMode } = this.props;
        const result = await InAppBrowser.open(url, {
          // iOS Properties
          dismissButtonStyle: "cancel",
          preferredBarTintColor: darkMode ? "#000000" : "#ffffff",
          preferredControlTintColor: darkMode ? "#ffffff" : "#000000",
          readerMode: false,
          animated: true,
          modalPresentationStyle: "fullScreen",
          modalTransitionStyle: "coverVertical",
          modalEnabled: true,
          enableBarCollapsing: false,

          toolbarColor: darkMode ? "#000000" : "#ffffff",

          animations: {
            startEnter: "slide_in_right",
            startExit: "slide_out_left",
            endEnter: "slide_in_left",
            endExit: "slide_out_right",
          },
        });
      } else {
        Linking.openURL(url);
      }
    } catch (error) {
      console.log("check error =>", error);
      // Alert.alert(error.message)
    }
  }

  render() {
    const { catchUp } = this.props;
    let webView = helpers.isWeb();
    let btnClickYoutube;
    if (webView) {
      btnClickYoutube = {
        href: "https://themorningcontext.com/tmc-private",
        handleClick: () => {
          this.pushInformationToDataLayer();
        },
      };
    } else {
      btnClickYoutube = {
        onPress: () =>
          this.openLink("https://themorningcontext.com/tmc-private"),
      };
    }
    // const joinyoutubebanner = helpers.isDesktop()? require("../../../../assets/img/JoinBanner.png") : require("../../../../assets/img/JoinBannerMobile.png")
    const joinyoutubebannerweb = getImagePath("img/footerlogo.png");
    const joinyoutubebannermobile = getImagePath("img/illustration.png");

    let {
      fulWidth,
      subscription,
      lightBlueBg,
      home,
      postSingle,
      darkMode,
      studentSubscription,
      whiteBg,
    } = this.props;
    return (
      <View
        style={[
          {
            flexDirection: helpers.isDesktop() ? "row" : "column",
            justifyContent: "space-evenly",
            alignContent: "center",
            padding: helpers.isDesktop() ? 70 : 20,
            width: "100%",
          },
          !darkMode && { backgroundColor: "#F3F5FF" },
          !helpers.isDesktop() && { paddingTop: 48, paddingBottom: 48 },
        ]}
      >
        {helpers.isDesktop() ? (
          <>
            <View style={[{ zIndex: 2, width: "40%", marginLeft: 50 }]}>
              {/* <Text style={[bannerStyles.heading, { fontSize: helpers.isDesktop() ? 70 : 30, marginBottom: 10 }, helpers.isWeb() && { fontWeight: FontWeight.bold}, !helpers.isWeb() && {fontFamily: FontFamily.semiBold}]}>Context is everything.</Text>
                      <Text accessibilityRole="header" aria-level="1" style={[bannerStyles.heading, { fontSize: helpers.isDesktop() ? 45 : 20, marginBottom: 10 }, helpers.isWeb() && { fontWeight: FontWeight.bold}, !helpers.isWeb() && {fontFamily: FontFamily.semiBold}]}>Only read stories that matter.</Text> */}

              {!catchUp && (
                <Text
                  accessibilityRole="header"
                  aria-level="1"
                  style={[
                    bannerStyles.heading,
                    {
                      color: darkMode ? "white" : "#171717",
                      fontFamily: "PlayfairDisplay-Bold",
                      fontSize: helpers.isDesktop() ? 44 : 16,
                      marginTop: 30,
                      top: 5,
                      fontWeight: 700,
                    },
                  ]}
                >
                  Join TMC Private
                </Text>
              )}
              {catchUp && (
                <Text
                  accessibilityRole="header"
                  aria-level="1"
                  style={[
                    bannerStyles.heading,
                    {
                      color: darkMode ? "white" : "#171717",
                      fontFamily: "PlayfairDisplay-Bold",
                      fontSize: helpers.isDesktop() ? 44 : 16,
                      marginTop: 30,
                      top: 5,
                      fontWeight: 700,
                    },
                  ]}
                >
                  Join TMC Private
                </Text>
              )}

              <Text
                style={[
                  bannerStyles.heading,
                  {
                    color: darkMode ? "white" : "#171717",
                    width: helpers.isDesktop ? "80%" : "auto",
                    fontSize: helpers.isDesktop() ? 24 : 17,
                    marginTop: 30,
                    top: 5,
                    fontFamily: "Merriweather-Regular",
                    fontWeight: 400,
                  },
                ]}
              >
                Meet fellow subscribers, share perspectives, and be part of a
                deeper offline TMC community experience.
              </Text>

              <View
                style={
                  ([helpers.isDesktop() && Flex.row, Margin.mt_2],
                  { alignSelf: "flex-start", marginTop: 30 })
                }
              >
                <TouchableOpacityLinkExternal {...btnClickYoutube}>
                  <Text
                    style={{
                      backgroundColor: "#1E1B4B",
                      color: "#fff",
                      width: 175,
                      textAlign: "center",
                      fontFamily: "HaasGrotesk-Medium",
                      fontWeight: 500,
                      fontSize: 17,
                      lineHeight: 23.5,
                      paddingHorizontal: 20,
                      paddingVertical: 12,
                    }}
                  >
                    LEARN MORE
                  </Text>
                </TouchableOpacityLinkExternal>
              </View>
            </View>
            <View style={{ marginRight: 100 }}>
              <CustomImage
                source={darkMode ? EventTicket : EventTicket}
                require={true}
                //   style={{ width: 500, height: helpers.isDesktop() ? 200 : 300 }}
                webStyle={{ width: 475, height: 300 }}
                altText={"The Morning Context"}
              />
            </View>
          </>
        ) : (
          <>
            <View style={[{ zIndex: 2 }]}>
              {!catchUp && (
                <Text
                  accessibilityRole="header"
                  aria-level="1"
                  style={[
                    Helpers.textCenter,
                    Typo.h3_R,
                    helpers.isDesktop() && Typo.h3_RDesktop,
                    Margin.mb_3,
                    { fontFamily: FontFamily.abrilFatface },
                    {
                      fontSize: 32,
                      lineHeight: 47,
                      marginBottom: 15,
                      color: "#171717",
                      fontWeight: 700,
                      fontFamily: "PlayfairDisplay-Bold",
                    },
                    darkMode && { color: Colors.lightWhite },
                  ]}
                >
                  Join TMC Private
                </Text>
              )}
              {catchUp && (
                <Text
                  accessibilityRole="header"
                  aria-level="1"
                  style={[
                    Helpers.textCenter,
                    Typo.h3_R,
                    helpers.isDesktop() && Typo.h3_RDesktop,
                    Margin.mb_0,
                    { fontFamily: FontFamily.abrilFatface },
                    {
                      fontSize: 32,
                      lineHeight: 47,
                      color: "#171717",
                      paddingBottom: 15,
                      fontFamily: "PlayfairDisplay-Bold",
                      fontWeight: 700,
                    },
                    darkMode && { color: Colors.lightWhite },
                  ]}
                >
                  Join TMC Private
                </Text>
              )}
              <View
                style={{
                  borderWidth: helpers.isDesktop() ? 1 : 0,
                  borderLeftColor: "black",
                  width: 50,
                  alignSelf: "center",
                }}
              />

              <Text
                style={[
                  bannerStyles.heading,
                  {
                    color: "#171717",
                    alignSelf: "center",
                    textAlign: "center",
                    fontSize: 18,
                    lineHeight: 28.4,
                    fontFamily: "Merriweather-Regular",
                    fontWeight: 400,
                  },
                ]}
              >
                Meet fellow subscribers, share perspectives, and be part of a
                deeper offline TMC community experience.
              </Text>
              {!helpers.isDesktop() && (
                <CustomImage
                  source={darkMode ? EventTicket : EventTicket}
                  require={true}
                  style={{ height: helpers.isDesktop() ? 200 : 300 }}
                  webStyle={
                    ({ width: "auto", height: "auto" },
                    !helpers.isDesktop() && { paddingBottom: 20 })
                  }
                  altText={"The Morning Context"}
                />
              )}
              <View style={{ alignSelf: "center", padding: 20 }}>
                <TouchableOpacityLinkExternal {...btnClickYoutube}>
                  <Text
                    style={{
                      backgroundColor: "#1E1B4B",
                      color: "#fff",
                      width: 175,
                      textAlign: "center",
                      fontFamily: "HaasGrotesk-Medium",
                      fontWeight: 500,
                      fontSize: 17,
                      lineHeight: 23.5,
                      paddingHorizontal: 20,
                      paddingVertical: 12,
                    }}
                  >
                    LEARN MORE
                  </Text>
                </TouchableOpacityLinkExternal>
              </View>
            </View>
          </>
        )}
      </View>
    );
  }
}

export default JoinYoutube;
